"use client";

import { useEffect } from "react";
import { X } from "lucide-react";
import { isYoutubeUrl, toYoutubeEmbedUrl } from "./video";

const DEFAULT_VIDEO_URL = "https://www.youtube.com/embed/CwE59Z9sZxY?si=t-maK4AHMr1x0xEY";

export function VideoModal({ videoUrl, onClose }: { videoUrl?: string | null; onClose: () => void }) {
  const source = videoUrl || DEFAULT_VIDEO_URL;
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl rounded-2xl overflow-hidden shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 flex items-center justify-center text-white transition-colors"
        >
          <X size={18} />
        </button>
        <div className="aspect-video bg-black">
          {isYoutubeUrl(source) ? (
            <iframe
              className="w-full h-full"
              src={toYoutubeEmbedUrl(source)}
              title="Video Profil SMAIT Ihsanul Fikri"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          ) : (
            <video className="w-full h-full" src={source} controls autoPlay playsInline />
          )}
        </div>
      </div>
    </div>
  );
}
